import {HttpClient} from '@angular/common/http'
import {inject, Injectable} from '@angular/core'
import {IKulladalUser} from '@kdl/kulladal-product-backend'
import {Observable} from 'rxjs'
import {environment} from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly httpClient: HttpClient = inject(HttpClient)

  public getUserSelf(): Observable<IKulladalUser> {
    const url = `${environment.millApiUrl}/users/self`
    return this.httpClient.get<IKulladalUser>(url)
  }
}
